import type { LogLevel } from 'configcat-react';

const asBool = (value: string | undefined): boolean => value === 'true';

export const knownFeatureFlags = { ENABLE_APP: 'enableApp' } as const;
export type KnownFeatureFlags = (typeof knownFeatureFlags)[keyof typeof knownFeatureFlags];
export type FeatureFlagDefaults = Record<KnownFeatureFlags, boolean>;

export type ConfigState = {
    backend: {
        AUTHENTICATION_SERVICE: string | undefined;
        ASSETS_API: string | undefined;
        IAM_API: string | undefined;
        MENU_SERVICE: string | undefined;
    };
    id: string | undefined;
    login: {
        authority: string | undefined;
        clientId: string | undefined;
        oauthScope: string[];
        mockAuthorization: boolean;
        mockLocale: string | undefined;
        mockTenant: string | undefined;
        preventRedirect: boolean;
        redirectUri: string | undefined;
        silentRedirectUri: string | undefined;
    };
    serviceEnvironment: string;
    enableMockServer: boolean;
    logoutUri: string | undefined;
    trunkVer: string | undefined;
    sentryToken: string | undefined;
    sentryModuleName: string;
    configCat: {
        apiKey: string;
        logLevel: LogLevel | undefined;
        pollingFrequencyInSeconds: number;
        defaults: FeatureFlagDefaults;
    };
};

export const config: ConfigState = {
    backend: {
        AUTHENTICATION_SERVICE: import.meta.env.VITE_AUTHENTICATION_SERVICE,
        ASSETS_API: import.meta.env.VITE_ASSETS_API,
        IAM_API: import.meta.env.VITE_IAM_API,
        MENU_SERVICE: import.meta.env.VITE_MENU_SERVICE,
    },
    id: import.meta.env.VITE_ID,
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
        oauthScope: ['openid', 'profile', 'email'],
        mockAuthorization: import.meta.env.DEV,
        mockLocale: import.meta.env.VITE_LOGIN_MOCK_LOCALE,
        mockTenant: import.meta.env.VITE_LOGIN_MOCK_TENANT,
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
    },
    serviceEnvironment: import.meta.env.MODE,
    enableMockServer: import.meta.env.DEV,
    logoutUri: import.meta.env.VITE_LOGOUT_URI,
    trunkVer: import.meta.env.VITE_TRUNK_VER,
    sentryToken: import.meta.env.VITE_SENTRY_DSN,
    sentryModuleName: 'manEulaConsent',
    configCat: {
        apiKey: 'configcat-sdk-1/h2PcCB-vwkGH3lT-3TyIsQ/SOv1yl-p8EC5IJDDa9qiYg',
        logLevel: undefined,
        // logLevel: import.meta.env.VITE_CONFIG_CAT_LOG_LEVEL === 'INFO' ? LogLevel.Info : LogLevel.Off,
        pollingFrequencyInSeconds: 600,
        defaults: {
            [knownFeatureFlags.ENABLE_APP]: true,
        },
    },
};
